/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description Component for Record Payment Button
 */
import { Button, ButtonProps } from 'antd';
import { Plus } from '@icon-park/react';
import { Link } from 'react-router-dom';

import { getRecordPaymentPath } from 'utils/router';

/**
 * Record Payment Button
 */
const RecordPayment: React.FC<ButtonProps> = (props) => {
	return (
		<Link to={getRecordPaymentPath()}>
			<Button type='primary' {...props}>
				<Plus />
				{'Record Payment'}
			</Button>
		</Link>
	);
};

export default RecordPayment;
